import Box from "@mui/material/Box";
import { useEffect } from "react";
import { Redirect, useLocation } from "react-router";

const Logout = (props) => {
	const location = useLocation()
	useEffect(() => {
			window.location.href = `gr.periferia.transports://logout`;
	}, [])
	if(location.pathname === '/logout') return <Redirect to={'/'}/>
	
	return (
		<Box>You are being logged out</Box>
	);
};

export default Logout